import { useSearchParams } from "next/navigation";

export function useIsOpenedFromApp(): boolean {
  return useSearchParams().get("from") === "app";
}

export function withFromApp(href: string, isFromApp: boolean): string {
  if (!isFromApp) return href;

  return `${href}${href.includes("?") ? "&" : "?"}from=app`;
}
